import ConfirmationPage from '../../shared/booking/ConfirmationPage';
import BusSummary from './BusSummary';
import BusTrip from './BusTrip';

export default function BusConfirmation() {
  return (
    <ConfirmationPage
      module="bus"
      Summary={BusSummary}
      refLabel="Operator PNR"
      Extra={BusTrip}
      nextSteps={[
        'Your e-ticket has been emailed — show it on your phone or as a printout when boarding.',
        'Reach the boarding point at least 15 minutes before the boarding time.',
        'Carry a valid government photo ID for every passenger.',
        'Cancel online from My Trips; the refund depends on how long before departure you cancel.',
      ]}
    />
  );
}
